module.exports = __webpack_public_path__ + "img/konto-icon.1d961393.svg";